import React, { useState,useEffect } from "react";
import axios from "axios";
import { Container, Form, Button, Row, Col, Table } from "react-bootstrap";
import Swal from 'sweetalert2';

const RabMeetForm = () => {
  const [userId, setUserId] = useState("");
  const [rabDate, setRabDate] = useState("2025-02-26");
  const [file_path, setFile_Path] = useState("");
  const [rabmeets, setRabmeets] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [users, setUsers] = useState([]);
 
  const [searchQuery, setSearchQuery] = useState('');


  // Fetch all users
  useEffect(() => {
    const getUsers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users`);
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    getUsers();
  }, []);



  const fetchRabmeets = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/rabmeet/all`);
      const data = await response.json();
      setRabmeets(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchRabmeets();
}, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file =="cfghg") {
      alert("Alert");
       return;
   }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.replace(/^data:.+;base64,/, "");
      setFile_Path(base64String);
    };

    if (file) {
      reader.readAsDataURL(file);
  }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!userId || !document) {
    Swal.fire({
      icon: "warning",
      title: "Missing Information",
      text: "Please enter user ID and select a valid file.",
    });
    return;
  }

  const data = { user_id: userId, rab_meet: rabDate, file_path };

  try {
    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/rabmeet/add`, data);
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "Your Presentation for RAB Meet submitted successfully.",
    });
  } catch (error) {
    console.error("Error submitting RabMeet:", error);
    Swal.fire({
      icon: "error",
      title: "Submission Failed",
      text: "There was an issue submitting your RAB Meet. Please try again.",
    });
  }
};

  const handleOpenFile = (file_path) => {
    if (!file_path) {
        alert("File path not found");
        return;
    }
    const filepath = `${process.env.REACT_APP_FILE_URL || 'https://ooo-toddler-gifts-pubs.trycloudflare.comloudflare.com'}/uploads/${file_path}`;
    window.open(filepath, "_blank");
};

  const toggleView = () => {
    if (!showTable) fetchRabmeets();
    setShowTable(!showTable);
  };


    // Filter users based on the search query
  const filteredUsers = users.filter((user) =>
    user.username && user.username.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Container
      className="d-flex align-items-start vh-100"
      style={{
        justifyContent: showTable ? "space-between" : "center",
        transition: "justify-content 0.3s ease",
      }}
    >
      {/* FORM CONTAINER */}
      <div
        className="p-4 rounded shadow-lg bg-white"
        style={{
          width: "500px",
          marginTop: "90px",
          transition: "margin-left 0.3s ease, margin-right 0.3s ease",
          marginLeft: showTable ? "0px" : "auto",
          marginRight: showTable ? "0px" : "auto",
        }}
      >
        <h2 className="text-center mb-4" style={{ color: "navy" }}>RAB Meet</h2>
       
        <Form onSubmit={handleSubmit}>
        <Form.Group controlId="userId">
      <Form.Label>User ID:</Form.Label>

      

      {/* Select Box to select a user */}
      <Form.Control
        as="select"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
        required
      >
        <option value="">Select User</option>
        {filteredUsers.length > 0 ? (
          filteredUsers.map((user) => (
            <option key={user.userId} value={user.userId}>
              {user.userId} {user.username}
            </option>
          ))
        ) : (
          <option>No users found</option>
        )}
      </Form.Control>
    </Form.Group>
  
          <Form.Group controlId="rabDate" className="mt-3">
            <Form.Label>RAB Meet Date:</Form.Label>
            <Form.Control type="date" value={rabDate} readOnly />
          </Form.Group>

          <Form.Group controlId="fileUpload" className="mt-3">
            <Form.Label>Upload File (only PPT OF SIZE:19MB)</Form.Label>
            <Form.Control type="file" accept=".pdf,.docx,.pptx" onChange={handleFileChange} required />
          </Form.Group>

          <Row className="mt-4">
            <Col className="d-flex justify-content-between">
            <Button
  type="submit"
  style={{ backgroundColor: "navy", borderColor: "navy" }}
  size="sm"
  
>
  Submit
</Button>
              <Button
                style={{ backgroundColor: "navy", borderColor: "navy" }}
                size="sm"
                onClick={toggleView}
              >
                {showTable ? "Hide" : "View"}
              </Button> 
            </Col>
          </Row>
        </Form>
      </div>

      {/* TABLE CONTAINER (Only Visible When 'View' is Clicked) */}
      {showTable && (
        <div
          className="p-4 rounded shadow-lg bg-white"
          style={{
            width: "700px",
            marginTop: "90px",
            transition: "width 0.3s ease",
          }}
        >
          <h2 className="text-center" style={{ color: "navy" }}>RAB Meet List</h2>
          <Table striped bordered hover className="mt-3">
            <thead>
              <tr>
                <th>User ID</th>
                <th>File Path</th>
                <th>RAB Date</th>
              </tr>
            </thead>
            <tbody>
                    {rabmeets.map((rabmeet) => (
                        <tr key={rabmeet.user_id}>
                            <td>{rabmeet.user_id}</td>
                            <a href='#' style={{cursor: "pointer"}} onClick={() => handleOpenFile(rabmeet.file_path)}>Link</a>
                            <td>{rabmeet.rab_meet}</td>
                        </tr>
                    ))}
                </tbody>
          </Table>
        </div>
      )}
    </Container>
  );
};

export default RabMeetForm;
